import { Instance } from "../lib/kotenna/Instance";
import { CloudProvider } from "../lib/kotenna/CloudProvider";
import { VHost } from "../lib/kotenna/VHost";

export interface CloudProviderWorker {

    createVhost(hostname: string, instance: Instance, provider: CloudProvider, tpl: any): Promise<VHost>;

    createProvider(): Promise<CloudProvider>;

}